( function ( $ ) {
	const toggleOpen = $("#toggle-open");
	const toggleClose = $("#toggle-close");
	const navigation = $(".navbar-nav-wrapper");

	toggleOpen.on("click", function(e) {
		navigation.addClass("open");
	});

	toggleClose.on("click", function(e) {
		navigation.removeClass("open");
	});
} )( jQuery );
